import { FormFieldTypes } from "../../../../data/formFieldType";

export const AddSGBSCategoryData = {
  name: "AdditionalInfo",
  initialState: {
    category: null,
    code: null,
    certificateTemplate: null,
  },
  formFields: [
    {
      id: "Category",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "Category",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-12 mb-3 w-250",
      },
    },
    {
      id: "code",
      lable: "Code",
      Field_Name: "Code",
      fieldType: FormFieldTypes.SELECT,
      dataField: "code",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "certificateTemplate",
      lable: "Certificate Template",
      Field_Name: "Certificate Template",
      fieldType: FormFieldTypes.SELECT,
      dataField: "certificateTemplate",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
